import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import logo from '../../assets/images/Dadi-logo.svg';
import sasiKiran from '../../assets/images/Dr.Sasi-Kiran-Attili.svg';
import nandaKumar from '../../assets/images/Dr.G.Nandakumar.svg';
import manojSingh from '../../assets/images/Dr.Manoj.svg';

const FACULTY = [
    {
        img: sasiKiran,
        name: "Dr. Sasi Kiran Attili",
        bio: "Editor-in-Chief of Indian Journal of Dermatopathology & Diagnostic Dermatology, National Quiz Master, with over 150+ presentations.",
    },
    {
        img: nandaKumar,
        name: "Dr. G. Nandakumar",
        bio: "Award-winning educator (IADVL Best Teacher 2024), with 200+ presentations.",
    },
    {
        img: manojSingh,
        name: "Dr. Manoj Singh",
        bio: "Founder of India's first dermatopathology lab at AIIMS, B C Roy Award recipient.",
    },
];

const Fellowship = () => {
    const navigate = useNavigate();
    const [interestRegistered, setInterestRegistered] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        const userId = localStorage.getItem("userId");
        if (userId && localStorage.getItem(`fellowshipInterest_${userId}`) === "true") {
            setInterestRegistered(true);
        }
    }, []);

    const handleRegisterInterest = () => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/login");
             localStorage.setItem(`fellowshipInterest`, "true");
             localStorage.setItem(`fellowshipInterestDate`, new Date().toISOString());
            return;
        }
        const userId = localStorage.getItem("userId");
        localStorage.setItem(`fellowshipInterest_${userId}`, "true");
        setInterestRegistered(true);
    };

    return (
        <>
            <Header />

            <div className="fellowship-page">
                <section className="fellowship-banner text-center">
                    <div className="container fellowship-banner-content" style={{ maxWidth: "900px" }}>
                        <div className="fellowship-logo-badge mb-4">
                            <img src={logo} alt="DADI Logo" width="170" />
                        </div>
                        <h1 className="txt-48 text-light mb-3 fw-bold">DADI Dermatopathology Fellowship</h1>
                        <p className="txt-22 text-light mb-4" style={{ opacity: 0.9 }}>
                            One-Year Basic Fellowship&nbsp;|&nbsp;Two-Year Advanced Fellowship
                        </p>
                        <span className="fellowship-status-pill">
                            <span className="fellowship-status-dot"></span>
                            Programmes under development
                        </span>
                    </div>
                </section>

                <section className="fellowship-section-light pt-5 pb-3">
                    <div className="container" style={{ maxWidth: "1000px" }}>
                        <div className="fellowship-info-card mb-4">
                            <h3 className="mb-3">DADI Dermatopathology Fellowship Programmes</h3>
                            <p className="txt-16 text-secondary mb-0">
                                DADI is developing structured fellowship programmes in dermatopathology based on
                                lectures, digital slide review, case discussions, clinicopathological correlation
                                and expert-led teaching.
                            </p>
                        </div>

                        <div className="fellowship-timeline">
                            <div className="fellowship-timeline-item one-year">
                                <div className="fellowship-timeline-marker">1 YR</div>
                                <div className="fellowship-timeline-content">
                                    <h5 className="fw-semibold mb-2">One-Year Basic Fellowship in Dermatopathology</h5>
                                    <p className="txt-16 text-secondary mb-0">
                                        A proposed foundational programme covering the systematic diagnosis of
                                        inflammatory, neoplastic and other major areas of dermatopathology.
                                    </p>
                                </div>
                            </div>
                            <div className="fellowship-timeline-item two-year">
                                <div className="fellowship-timeline-marker">2 YR</div>
                                <div className="fellowship-timeline-content">
                                    <h5 className="fw-semibold mb-2">Two-Year Advanced Fellowship in Dermatopathology</h5>
                                    <p className="txt-16 text-secondary">
                                        A proposed advanced programme offering extended diagnostic training and
                                        greater case-based exposure.
                                    </p>
                                    <p className="txt-16 text-secondary">
                                        Planned to include a three-month in-person training stint in dermatology
                                        or pathology, depending on the candidate's primary specialty.
                                    </p>
                                    <p className="txt-16 text-secondary">
                                        Also designed to prepare eligible candidates to take the International
                                        Diploma in Dermatopathology examination.
                                    </p>
                                    <p className="txt-16 text-secondary">
                                        An exit examination and fellowship certification may be offered after
                                        successful completion, subject to final institutional approval and
                                        programme regulations.
                                    </p>
                                    <p className="txt-16 text-secondary mb-0">
                                        Standalone dermatopathology learning modules are also planned and will
                                        be introduced later.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pt-3 pb-5">
                    <div className="container" style={{ maxWidth: "800px" }}>
                        <div className="fellowship-status-card">
                            <h5 className="fw-semibold mb-3">Current Programme Status</h5>
                            <ul className="fellowship-checklist">
                                <li>The fellowship programmes are currently being finalised.</li>
                                <li>
                                    DADI is awaiting confirmation regarding proposed academic collaboration
                                    with <span className="fw-semibold">GITAM (Deemed to be University)</span>.
                                </li>
                                <li>
                                    The final curriculum, eligibility, fees, certification, training format
                                    and commencement dates will be announced after completion of the
                                    institutional approval process.
                                </li>
                                <li className="fw-semibold">Applications are not currently open.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="pb-3">
                    <div className="container text-center" style={{ maxWidth: "700px" }}>
                        <div className="fellowship-register-card">
                            {interestRegistered ? (
                                <>
                                    <button className="fellowship-register-btn" disabled>
                                        Interest Registered <span className="ms-1">&#10003;</span>
                                    </button>
                                    <p className="txt-16 mt-3 mb-0 mx-auto" style={{ maxWidth: "520px", opacity: 0.9 }}>
                                        Your interest has been registered. We will notify you when the fellowship
                                        structure and application process are formally announced.
                                    </p>
                                </>
                            ) : (
                                <>
                                    <h5 className="fw-bold mb-3">Stay Updated</h5>
                                    <p className="txt-16 mb-3" style={{ opacity: 0.9 }}>
                                        Register your interest to be notified as soon as the fellowship structure
                                        and application process are formally announced.
                                    </p>
                                    <button className="fellowship-register-btn" onClick={handleRegisterInterest}>
                                        Register Interest
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </section>

                <section className="fellowship-section-light pt-3 pb-3">
                    <div className="container" style={{ maxWidth: "1000px" }}>
                        <div className="text-center mb-4">
                            <h3>Academic Faculty</h3>
                        </div>

                        <div className="fellowship-faculty-row">
                            {FACULTY.map((member) => (
                                <div key={member.name} className="fellowship-faculty-col">
                                    <div className="fellowship-faculty-card">
                                        <img src={member.img} alt={member.name} className="fellowship-faculty-img" />
                                        <h6 className="fw-bold mb-2">{member.name}</h6>
                                        <p className="txt-14 text-secondary mb-0">{member.bio}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="pt-4 pb-4">
                    <div className="container" style={{ maxWidth: "800px" }}>
                        <div className="fellowship-disclaimer">
                            <p className="txt-13 text-secondary text-center mb-0">
                                The fellowship programmes are proposed and subject to institutional approval and
                                finalisation. Registration of interest is not an application, admission offer or
                                guarantee of certification. Programme details may change before the formal launch.
                            </p>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </>
    );
};

export default Fellowship;